import {ACCIDENT_PARTIES_AT_FAULT_OPTIONS, ACCIDENT_TYPE_OPTIONS, YES_NO_CHOICE_OPTIONS} from "@constants/dropdown-choices";
import DynamicItemHeadingComponent from "@components/common/ui-elements/headings/dynamic-item-heading";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import ScrollableCustomDateTimePickerBlock
    from "@components/common/form-blocks/scrollable/custom-datetime-picker-block";
import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";
import ScrollableDropdownBlock from "@components/common/form-blocks/scrollable/dropdown-block";

export default function PolicyHolderAccidentForm(
    {
        accident,
        driverIndex,
        accidentIndex,
        motorAccidentsListPropName,
        handlePolicyHolderAccidentPropChange ,
        addPolicyHolderAccident ,
        removePolicyHolderAccident,
    }
) {

    const generateName = (prop) => {
        return `${motorAccidentsListPropName}[${accidentIndex}][${prop}]`;
    }
   
   const generateDataBlock = (prop) => {
      return `${motorAccidentsListPropName}.${accidentIndex}.${prop}`;
   }

    const generateIdPrefix = (prop) => {
        return `${motorAccidentsListPropName}-${accidentIndex}-${prop}-`;
    }

    return (
        <div className="policy-holder-accident-block hidden-box row">

            <DynamicItemHeadingComponent
                text="Accident"
                itemIndex={accidentIndex + 1}
                onRemoveIconClick={(e) => removePolicyHolderAccident(accidentIndex)}
            />
           

            {/* What type of incident was it? */}

            <ScrollableButtonGroupBlock
                containerCssClass="col-12 py-3 "
                labelText="What type of incident was it?"
                required={true}
                controlName={generateName('type')}
                dataBlock={generateDataBlock('type')}
                options={ACCIDENT_TYPE_OPTIONS}
                selectedValues={accident.type}
                onChange={(e) => handlePolicyHolderAccidentPropChange(accidentIndex, 'type', e.target.value)}
                btnGroupAttrs={{
                    className: 'btn-group vertical-mobile'
                }}
            />


            {/* Date */}

            <ScrollableCustomDateTimePickerBlock
                containerCssClass="col-12 py-3 col-md-6"
                labelText="Date"
                required={true}
                controlName={generateName('date')}
                dataBlock={generateDataBlock('date')}
                value={accident.date}
                onChange={(e) => handlePolicyHolderAccidentPropChange(accidentIndex, 'date', e.target.value)}
            />
           

            {/* Who is at fault? */}

            <ScrollableDropdownBlock
                controlName={generateName('partyAtFault')}
                dataBlock={generateDataBlock('partyAtFault')}
                containerCssClass="col-12 col-md-6 py-3 "
                labelText="Who is at fault?"
                required={true}
                options={ACCIDENT_PARTIES_AT_FAULT_OPTIONS}
                selectedValues={accident.partyAtFault}
                onChange={(e) => handlePolicyHolderAccidentPropChange(accidentIndex, 'partyAtFault', e.target.value)}
                helpText=""
            />

           
        </div>
    );

}